import React from "react";
import Search from "assets/images/search.png";
import Clear from "assets/images/clear.png";
import "./index.less";
import { chooseModel, setKey, setTime, setShop } from "tools/store";
import { connect } from "react-redux";
import WebApi from "tools/webApi";
import Mobile from "assets/images/mobile.png";
import intl from "react-intl-universal";
import Gtinit from 'tools/gt'
//全局状态
const mapStateToProps = (state: any) => {
  return {
    model: state.defaultState.model,
    countryActive: state.defaultState.countryActive,
    keyword: state.defaultState.keyword,
    isDeliverySite: state.defaultState.isDeliverySite,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  chooseModel: (v: any) => {
    dispatch(chooseModel(v));
  },
  setKey: (v: any) => {
    dispatch(setKey(v));
  },
  setShop: (v: any) => {
    dispatch(setShop(v));
  },
  setTime: (v: any) => {
    dispatch(setTime(v));
  },
});
@(connect(mapStateToProps, mapDispatchToProps) as any)
class Model extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      searchText: "", //搜索框内容
      saveText: "",
      leftSelected: 0,
      rightSelected: -1, //右侧选中数据
      middleSelected:0,
      list1: [],
    };
  }

  //搜索框
  textChange = (e: any) => {
    this.setState({
      searchText: e.target.value,
    });
  };
  inputOnBlur = () => {
    this.getList("keyword");
  };
  inputOnClear = () => {
    this.setState({
      searchText: "",
    });
    this.getList("");
  }; //清空
  inputPress = (e: any) => {
    if (+e.keyCode === 13) {
      this.inputOnBlur();
    }
  };
  //左侧选择
  leftSelect = (i: number) => {
    this.setState({
      leftSelected: i,
      middleSelected:0,
      rightSelected: -1,
    });
  };
  // 中间选择
  middleSelect = (i: number) => {
    this.setState({
      middleSelected:i,
      rightSelected: -1,
    });
  };
  //右侧选择
  rightSelect = (i: number) => {
    if (this.props.model.rightCode === '') {
      // 谷歌埋点---打开预约页面，且在整个页面上填写了任意一项预约信息
      gtag('event', 'Reservation_details' + Gtinit());
    }

    this.setState({
      rightSelected: i,
    });
    let left = this.state.list1[this.state.leftSelected];
    let right = this.state.list1[this.state.leftSelected].list[this.state.middleSelected].list[i];
    let data = {
      leftName: left.brand,
      leftCode: this.state.leftSelected,
      rightName: right.model,
      rightCode: i,
      middleCode: this.state.middleSelected,
      rightIcon: right.img // 新增图标信息
    };
    console.log(data);
    this.props.setKey(this.state.saveText);
    this.props.chooseModel(data);

    if (!(this.props.isDeliverySite===1||this.props.isDeliverySite===2)) {
      if((window.location.href.indexOf('?shopId=KESI00060&country=Kenya')>-1)||
      (window.location.href.indexOf('?shopId=KESI00018&country=Kenya')>-1)
      ){
          // 不要清空
      }else{
        //清空绑定机型的数据
        this.props.setShop({
          storeName: "",
          storeCode: "",
          storeAddr: "",
        });
        this.props.setTime([]);
      }
    }
    gtag('event', 'Reservation_PV-model' + Gtinit());

    // window.history.go(-1);
    this.props.handle();
  };
  //获取列表
  async getList(v: any) {
    let data = {
      keyword: this.state.searchText,
      country: this.props.countryActive.name,
    };
    if (!v) {
      data = {
        keyword: this.props.keyword,
        country: this.props.countryActive.name,
      };
    }
    let res: any = await WebApi.getModels(data);
    if (res && res.code === "0"&& res.list.length>0) {
      let a: any = res.list;

      // 以下增加all
      let j: any = res.list;
      let b:any=[];
      j.forEach((va:any,ia:number) => {
        let b1=va.list;//子品牌层级
        b[ia]=[];
        b1.forEach((va1:any,ia1:number) => {
          b[ia]=b[ia].concat(va1.list)
        })
        console.log(b[ia])
        a[ia].list.unshift({
          series:intl.get('runame1')||"All",
          list:b[ia]
        })
      })

      a.push({ 
        "brand": intl.get('add2.name13'), 
        list: [{
          series:intl.get('add2.name13'),
          list:[{ model: intl.get('add2.name13') }]  
         }] 
      })
      this.setState({
        list1: a
      });

      if (v === "keyword" && res.list.length > 0) {
        this.setState({
          leftSelected: 0,
          middleSelected:0,
          rightSelected: -1,
          saveText: data.keyword,
        });
      }
      // 优化展示
      if(!this.props.model.leftName){
        if (a[0].list.length > 0) {
          this.setState({ leftSelected: 0,middleSelect:0 })
        } else if (a[1].list.length > 0) {
          this.setState({ leftSelected: 1,middleSelect:0 })
        } else if (a[2].list.length > 0) {
          this.setState({ leftSelected: 2,middleSelect:0 })
        } else {
          this.setState({ leftSelected: 3,middleSelect:0 })
        }
      }
    } else {
      this.setState({
        list1: [{ 
          "brand": intl.get('add2.name13'), 
          list: [{
            series:intl.get('add2.name13'),
            list:[{ model: intl.get('add2.name13') }]  
        }] 
          }],
        leftSelected: 0,
        middleSelected:0,
      });
    }
  }
  //生命周期
  componentDidMount() {
    this.setState({
      leftSelected: this.props.model.leftCode || 0,
      middleSelected: this.props.model.middleCode || 0,
      rightSelected: this.props.model.rightCode !== '' ? this.props.model.rightCode : -1,
      searchText: this.props.keyword || "",
      saveText: this.props.keyword || "",
    });
    this.getList("");
  }
  render() {
    return (
      <div className="pc_modelpage">
        <div className="part1">
          <div className="btn">
            <img src={Search} className="search" alt="" onClick={this.inputOnBlur} />
            <input
              type="text"
              onChange={this.textChange}
              value={this.state.searchText}
              onKeyUp={this.inputPress}
              maxLength={100}
              placeholder={intl.get("price.name2")}
            />
            <img src={Clear} className="clear" alt="" onClick={this.inputOnClear} />
          </div>
          {/* <div className="search" onClick={this.inputOnBlur} >{intl.get('runame2')||'search'}</div> */}
        </div>
        {this.state.list1.length > 0 ? (
          <div className="part2">
            <div className="brand-bar">
                  {this.state.list1.map((v: any, i: number) => (
                      <span
                          key={i}
                          onClick={this.leftSelect.bind(this, i)}
                          className={ +this.state.leftSelected === i? "brand-selected" : ""}
                      >
                          {v.brand}
                      </span>
                  ))}
              </div>

              <div className="brand-series-model-container">
                <div className="series-bar">
                    {this.state.list1[this.state.leftSelected]?.list.map((vv:any, ii: number) => (
                        <div
                            key={ii}
                            onClick={this.middleSelect.bind(this, ii)}
                            className={+this.state.middleSelected === ii? "series-selected" : ""}
                        >
                            {vv.series}
                        </div>
                    ))}
                </div>
                <div className="model-list">
                    {this.state.list1 && this.state.list1[this.state.leftSelected].list[this.state.middleSelected] && this.state.list1[this.state.leftSelected].list[this.state.middleSelected].list.map((v: any, i: number) => (
                        <div key={i} className="model-item" onClick={this.rightSelect.bind(this, i)}>
                            <div className="item-img">
                            <img src={v.img || Mobile} alt={v.model} />
                            </div>    
                            <p>{v.model}</p>
                        </div>
                    ))}
                </div>
            </div>
          </div>
        ) : (
          <div className="zero">
            {/* <Err content={"Sorry! Current country site has no price display"} /> */}
            <span>{intl.get("error.name1")}</span>
          </div>
        )}
      </div>
    );
  }
}

export default Model;
